import memoizeOne from 'memoize-one';

export const numberValueParser = memoizeOne((rawValue: any): number | undefined => {
  if (rawValue === null || rawValue === undefined) return undefined;
  return rawValue;
});